<template>
    <Modal maxWidth="290" :show.sync="$props.show" :persistent="true">
      <template v-slot:title>
        Ajouter contact
      </template>
      <template v-slot:text v-if="contactToAdd">
        Ajouter "{{contactToAdd.firstname}} {{contactToAdd.lastname}}" en tant que contact lié ?
      </template>
      <template v-slot:actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="add()"
          >
            Ajouter
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="cancel()"
          >
            Annuler
          </v-btn>
      </template>
    </Modal>
</template>
<script>
import Modal from '@/components/Modal/Modal';
export default {
  components: {
    Modal
  },
  data () {
    return {

    };
  },
  props: {
    contactToAdd: Object,
    show: Boolean,
    addContact: Function
  },
  methods: {
    add () {
      this.addContact();
      this.$store.commit('setAddContactMode', {
        active: false,
        contactToAdd: null,
        customer_uuid: null
      });
    },
    cancel () {
      this.$store.commit('setAddContactMode', {
        active: false,
        contactToAdd: null,
        customer_uuid: null
      });
    }
  },
  mounted () {

  }
};
</script>
<style>
.search-placeholder {
  min-height: 200px;
  text-align: center;
}
</style>
